import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LoadableSaveableBoolean } from '../loadable-saveable-boolean';

export const STATE_USER_SUBSCRIBED_RESOURCES = 'subscribedResources';

export interface UserResourceSubscriptionState {
  [resourceId: string]: LoadableSaveableBoolean;
}

export const USER_SUBSCRIBED_RESOURCES_INITIAL_STATE = {};

export function getInitialUserResourceSubscriptionState(): UserResourceSubscriptionState {
  return USER_SUBSCRIBED_RESOURCES_INITIAL_STATE;
}

export const selectResourceSubscriptionState =
  createFeatureSelector<UserResourceSubscriptionState>(
    STATE_USER_SUBSCRIBED_RESOURCES,
  );

export const selectResourceSubscriptionStatus = (resourceId: string) =>
  createSelector(selectResourceSubscriptionState, state => state[resourceId]);
